import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';

import { DomainPermission } from '../../types/DomainPermission';
import { DomainValidationStatus } from '../../types/DomainValidationStatus';
import { PoolAssignmentOption } from '../../types/PoolAssignmentOption';
import { PoolID } from '../../types/PoolID';
import { AddNewDomainDialog, AddNewDomainDialogInputProps, AddNewDomainDialogState } from './AddNewDomainDialog';

export function openEditDomainDialog(
    domainEditableProperties: { domainName: string, poolID: PoolID | null, domainPermission: DomainPermission },
    onEditDomainDialogSave: (domainName: string, poolID: PoolID | null, domainPermission: DomainPermission) => void,
    poolOptions: ReadonlyArray<PoolAssignmentOption>,
    otherDomainNames: ReadonlyArray<string>,
    dataConnectDomainNames: ReadonlyArray<string>
) {
    const action = (_props: AddNewDomainDialogInputProps, state: AddNewDomainDialogState) => {
        onEditDomainDialogSave(state.domainName, state.poolID, state.domainPermission);
        return Promise.resolve();
    };
    const dialogInstance = openReactActionDialog({
        title: Messages.bridgeSiteSettingsEditDomain(),
        bodyComponent: AddNewDomainDialog,
        initialBodyProps: { poolOptions, otherDomainNames,  dataConnectDomainNames},
        initialDialogState: { ...domainEditableProperties, domainValidationStatus: DomainValidationStatus.NO_ERROR   },
        actionDisabled: (_props, state) => state.domainValidationStatus !== DomainValidationStatus.NO_ERROR,
        actionName: Messages.save(),
        action: action,
        isActionDelete: false,
        dialogWidth: TabDialogWidth.width375px,
        dismissDialogOnActionFailed: false
    });

    return Promise.resolve(dialogInstance.result);
}
